var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import renderAllComponents from "./utils/app-related/renderAllComponents";
import aemComponentsMap from "./aem-components";
import partialsMap from "./partials";
var reactElementsMap = __assign(__assign({}, aemComponentsMap), partialsMap);
document.addEventListener("DOMContentLoaded", function () {
    renderAllComponents(reactElementsMap);
});
